import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const { setSession } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      setSession(data);
      nav("/admin/dashboard");
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center ip-gradient p-6">
      <div className="w-full max-w-sm bg-white rounded-2xl p-8 ip-card-shadow">
        <div className="flex justify-center mb-6"><Logo /></div>
        <div className="flex items-center justify-center gap-2 text-brand mb-1"><Lock className="h-4 w-4" /><span className="text-xs font-semibold uppercase tracking-[0.2em]">Admin Portal</span></div>
        <h2 className="text-2xl font-bold tracking-tight text-center">Sign in</h2>
        <p className="text-muted-foreground text-sm mt-1 mb-6 text-center">Authorized personnel only.</p>

        {err && <div data-testid="admin-login-error" className="mb-4 rounded-lg bg-rose-50 border border-rose-200 text-rose-700 text-sm px-3 py-2">{err}</div>}

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="admin-login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
          </div>
          <div>
            <div className="flex items-center justify-between">
              <Label htmlFor="password">Password</Label>
              <Link to="/admin/forgot-password" className="text-xs font-semibold text-brand hover:underline">Forgot password?</Link>
            </div>
            <Input id="password" data-testid="admin-login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11" data-testid="admin-login-submit-button">
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Sign In
          </Button>
        </form>
      </div>
    </div>
  );
}
